const formatCsvValue = (value) => {
  if (value === null || value === undefined) return "";
  const stringValue = String(value);
  if (/[",\n]/.test(stringValue)) {
    return '"' + stringValue.replace(/"/g, '""') + '"';
  }
  return stringValue;
};

export const buildCsv = (rows, headers) => {
  const lines = [headers.join(",")];
  rows.forEach((row) => {
    const amount = ((row?.amount || 0) / 100000).toFixed(2);
    const d = row?.createdAt ? new Date(row.createdAt) : null;
    const dateStr = d ? d.toLocaleDateString() : "";
    const timeStr = d ? d.toLocaleTimeString() : "";
    const line = [
      dateStr,
      timeStr,
      row?.action || "",
      row?.superadminAgent?.email || "",
      row?.prevCentralBalance != null ? parseFloat((row.prevCentralBalance / 100000).toFixed(8)) : "",
      amount,
      row?.message || "",
      row?.reasonCode || "",
      row?.balanceType || "",
      row?.financeAgent?.email || "",
      row?.paymentReceived ? "Yes" : "No",
      row?.financeRemark || "",
      row?.invoiceNumber || "",
      row?.orderId || "",
      row?.invoiceLink || "",
    ].map(formatCsvValue);
    lines.push(line.join(","));
  });
  return lines.join("\n");
};
